/*
 * BM-FE-TZ-002C: у каждой вкладки «Сводки» своё сохранённое состояние —
 * scope, правила, preset, точные from/to, фильтры и сортировка таблиц.
 * Хранится строка query самой вкладки (без tab): это ровно то, что вкладка
 * держит в URL, поэтому возврат, reload и Back дают те же даты, а не
 * «последние 7 дней».
 *
 * Переход в другую вкладку ничего не копирует: каждая читает только свой
 * ключ, поэтому rule_ids одной категории в другую не попадают. Явные
 * фильтры в URL главнее сохранённого состояния той же вкладки.
 */

export const TAB_STATE_KEYS = {
  violation: 'analyticsFilters.v1.violation',
  business: 'analyticsFilters.v1.business',
  system: 'analyticsFilters.v1.system',
};

export const TAB_KIND = {
  overview: 'violation',
  'business-metrics': 'business',
  issues: 'system',
};

const withoutTab = (searchParams) => {
  const next = new URLSearchParams(searchParams);
  next.delete('tab');
  return next;
};

// Открытая карточка проблемы — момент, а не состояние вкладки: при возврате
// она не должна всплывать снова.
const TRANSIENT_PARAMS = ['issue_id'];

/** В URL есть что-то, кроме tab — пользователь пришёл с явными фильтрами. */
export const hasOwnParams = (searchParams) => withoutTab(searchParams).toString() !== '';

export const saveTabState = (kind, searchParams) => {
  const key = TAB_STATE_KEYS[kind];
  if (!key) return;
  try {
    const next = withoutTab(searchParams);
    TRANSIENT_PARAMS.forEach((param) => next.delete(param));
    window.localStorage.setItem(key, next.toString());
  } catch {
    // Хранилище недоступно (приватный режим) — вкладка просто не восстановится.
  }
};

/** Сохранённые параметры вкладки или null, если сохранять было нечего. */
export const loadTabState = (kind) => {
  const key = TAB_STATE_KEYS[kind];
  if (!key) return null;
  try {
    const raw = window.localStorage.getItem(key);
    return raw ? new URLSearchParams(raw) : null;
  } catch {
    return null;
  }
};

/** URL вкладки: её сохранённое состояние плюс tab (у «Нарушений» tab нет). */
export const buildTabParams = (tabId, saved) => {
  const next = new URLSearchParams(saved || '');
  next.delete('tab');
  if (tabId !== 'overview') next.set('tab', tabId);
  return next;
};
